//function for desktop opener menu
$(document).on('click','.menu-opener',function(){
	$('.page').toggleClass('unfolded');
	if ($('.page').hasClass('unfolded')) {
		$('.title-open').removeClass('hidden');
		$('.title-close').addClass('hidden');
	} else {
		$('.title-close').removeClass('hidden');
		$('.title-open').addClass('hidden');
	}
});
//function for mobile opener menu
$(document).on('click','.fa-bars',function(){
	if ($('.fa-bars').hasClass('fa-rotate-90')) {
		$('.background-profil, .background-menu, .notifications').slideUp();
		$('.fa-bars').removeClass('fa-rotate-90');
	} else {
		$('.background-profil, .background-menu, .notifications').slideDown();
		$('.fa-bars').addClass('fa-rotate-90');
	}
});

$(window).on('load resize', function(){
	var win = $(this); //this = window
	if (win.width() >= 768 && win.width() < 1200) {
		$('.background-profil, .background-menu, .notifications').slideDown();
		$('.fa-bars').addClass('fa-rotate-90');
		$('.page').removeClass('unfolded')
	} else if (win.width() < 768) {
		$('.background-profil, .background-menu, .notifications').slideUp();
		$('.fa-bars').removeClass('fa-rotate-90');
		$('.page').addClass('unfolded');
	} else {
		$('.page').removeClass('unfolded')
	}
});



// WEBPACK FOOTER //
// ./assets/js/opener.js